import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/understanding-your-values-icon.svg';

type Props = WithTranslation;

export const UnderstandingYourValuesStep = withTranslation('cp')(({ t }: Props) => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading small>
                    {t('week-2.understanding-your-values.subheading')}
                </S.StepHeading>
                <S.StepHeading>{t('week-2.understanding-your-values.heading')}</S.StepHeading>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepDescription small>
                    {t('week-2.understanding-your-values.description.1')}
                </S.StepDescription>
                <S.StepDescription small>
                    {t('week-2.understanding-your-values.description.2')}
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
));
